import { useEffect } from 'react'
import { runInAction } from 'mobx'
import { WebsocketEvent } from 'entities/WebSocket'
import { Conversation } from 'entities/Conversation'
import { type IResponseEventMessage } from 'entities/Message'
import { Message } from 'entities/Message/model/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { ILocalTypeInbox } from 'entities/Inbox'
import { checkFilterSmartView } from 'entities/SmartViews/lib/checkFilterSmartView'
import {
  canAddConversationToList,
  type ConversationListStore,
} from 'pages/conversations/ui/ConversationList'

export const useEventVoicemailReceived = (
  conversationListStore: ConversationListStore,
  view: ILocalTypeInbox
) => {
  const entities = useEntitiesContext()
  const { conversationStore } = entities
  const handler = (data: IResponseEventMessage) => {
    const item = new Conversation(data.conversation, entities)
    const message = new Message(
      {
        message: data.message,
      },
      entities
    )
    const { conversationSearchStore, filtersStore } = conversationListStore
    const update = () => {
      conversationStore.updateItem(data.conversation)
      conversationListStore.updateItemOrder(item.id)
    }

    runInAction(() => {
      // Smart view
      if (view === 'smart_view') {
        const smartView = entities.inboxesStore.localInboxes.currentSmartView

        if (!smartView) return
        if (!checkFilterSmartView(item.smartViewFilterParams, smartView.filters)) return
        if (!filtersStore.isShowConversation(item, message)) return

        update()

        return
      }

      // Default
      if (conversationSearchStore.isActive) return
      if (!filtersStore.isShowConversation(item, message)) return
      if (canAddConversationToList(data.conversation, entities)) {
        update()
      }
    })
  }

  useEffect(() => entities.websocket.on(WebsocketEvent.VoicemailReceived, handler), [view])
}
